import type { StaffTeamApi } from "@lafayette/api-client";
import { createContext, type ReactNode, useContext } from "react";

// What the team, coverage and support screens need from outside: the typed client and the clock. The admin app supplies the real ones
// (`admin-runtime.ts`); a test or the development harness supplies fakes. The provider sits above the routes, so the support page of a
// customer (under Customers) reads the same runtime as the Staff and Coverage pages.

export type TeamRuntime = Readonly<{
  api: StaffTeamApi;
  now: () => Date;
}>;

const RuntimeContext = createContext<TeamRuntime | null>(null);

export function TeamRuntimeProvider({
  value,
  children,
}: Readonly<{ value: TeamRuntime; children: ReactNode }>) {
  return <RuntimeContext.Provider value={value}>{children}</RuntimeContext.Provider>;
}

export function useTeamRuntime(): TeamRuntime {
  const runtime = useContext(RuntimeContext);
  if (runtime === null) throw new Error("The team pages need a TeamRuntimeProvider.");
  return runtime;
}
